// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".device-bind-status[data-v-7a341907] {\n  display: inline-flex;\n  margin: 0 10px;\n}", ""]);
// Exports
module.exports = exports;
